import { ATexts } from '../../services/ATexts';
import type { IntranetEntryBody, IntranetEntryType } from '../../api/types/intranet.types';

/** The texts only the intranet module shows. */
class IntranetTextsClass extends ATexts {
    private readonly EntryHintLength = 25;

    public readonly Body = 'Inhalt';
    public readonly Empty = 'Es gibt noch kein Intranet.';
    public readonly EntriesEmpty = 'Keine Einträge';
    public readonly EntriesSort = 'Einträge sortieren';
    public readonly EntryCreate = 'Eintrag anlegen';
    public readonly EntryCreateAs = '{type} anlegen';
    public readonly EntryDelete = 'Eintrag löschen';
    public readonly EntryEdit = 'Eintrag bearbeiten';
    public readonly EntryTypes: Record<IntranetEntryType, string> = { text: 'Text-Block', php: 'PHP-Code' };
    public readonly EntryCountNone = 'Keine Einträge';
    public readonly EntryCountOne = '1 Eintrag';
    public readonly EntryCountMany = '{count} Einträge';
    public readonly EntryMoreLine = '… weitere 1 Zeile';
    public readonly EntryMoreLines = '… weitere {count} Zeilen';
    public readonly EntryView = 'Ansehen';
    public readonly IntranetCreate = 'Intranet anlegen';
    public readonly IntranetDelete = 'Intranet löschen';
    public readonly IntranetEdit = 'Intranet bearbeiten';
    public readonly IntranetId = 'Intranet-ID';
    public readonly IntranetName = 'Bezeichnung';
    public readonly IntranetOpen = 'Intranet öffnen';
    public readonly PathSeparator = ' | ';
    public readonly PointChoose = 'Punkt auswählen';
    public readonly PointCreateSub = 'Unterpunkt anlegen';
    public readonly PointDelete = 'Punkt löschen';
    public readonly PointEdit = 'Punkt bearbeiten';
    public readonly PointLabel = '{path} ({count})';
    public readonly PointName = 'Bezeichnung';
    public readonly PointParent = 'Übergeordneter Punkt';
    public readonly PointTop = 'Oberste Ebene';
    public readonly PointUsed = 'Ein Punkt mit Einträgen oder Unterpunkten lässt sich nicht löschen.';
    public readonly SubPointsEmpty = 'Keine Unterpunkte';
    public readonly SubPointsSort = 'Unterpunkte sortieren';
    public readonly Title = 'Titel';
    /** The part of an address when a name holds no letter or digit. */
    public readonly TokenFallback = 'seite';

    /** The title of an entry, the name of its type without one. */
    public getEntryCount(count: number): string {
        if (count === 0) {
            return this.EntryCountNone;
        }

        return count === 1 ? this.EntryCountOne : this.format(this.EntryCountMany, { count });
    }

    /** The start of an entry in one line, for a list. */
    public getEntryHint(entry: Pick<IntranetEntryBody, 'plain'>): string {
        const Line = entry.plain.replace(/\s+/g, ' ').trim();

        return Line.length > this.EntryHintLength ? `${Line.slice(0, this.EntryHintLength).trimEnd()}…` : Line;
    }

    public getEntryTitle(entry: Pick<IntranetEntryBody, 'entry_type' | 'title'>): string {
        const Title = entry.title ?? '';

        return Title === '' ? this.EntryTypes[entry.entry_type] : Title;
    }
}

export const IntranetTexts = new IntranetTextsClass();
